import { defineMessage } from 'react-intl';

export const lessonCommonI18n = {
  attendOffline: defineMessage({
    id: 'common:lesson.attend-offline',
    defaultMessage: 'Attend in-person'
  }),
  fullyBooked: defineMessage({
    id: 'common:lesson.fully-booked',
    defaultMessage: 'Fully booked'
  }),
  fullyBookedShort: defineMessage({
    id: 'common:lesson.fully-booked-short',
    defaultMessage: 'Full'
  }),
  offlineLesson: defineMessage({
    id: 'common:lesson.offline',
    defaultMessage: 'In-person lesson'
  }),
  offlineLessonShort: defineMessage({
    id: 'common:lesson.offline-short',
    defaultMessage: 'In-person'
  }),
  onlineLesson: defineMessage({
    id: 'common:lesson.online',
    defaultMessage: 'Online lesson'
  }),
  onlineLessonShort: defineMessage({
    id: 'common:lesson.online-short',
    defaultMessage: 'Online'
  }),
  pastLessons: defineMessage({
    id: 'common:lesson.past',
    defaultMessage: 'Past lessons'
  }),
  upcomingLessons: defineMessage({
    id: 'common:lesson.upcoming',
    defaultMessage: 'Upcoming lessons'
  })
};
